import { useTranslation } from 'react-i18next'


import { AppMarket } from '@widgets/app-market'

import { UNIFIED_APP_LINK } from '@shared/contants'
import QrCode from '@shared/ui/qrcode'

import styles from './styles.module.scss'



export default function BannerApp () {
  const { t: tb } = useTranslation('appBanner')

  return (
    <div className={styles.root}>
      <div className={styles.root__inner}>
        <img className={styles.root__img} src="/img/app/banner.png" alt="" />

        <div className={styles.root__text}>
          <h2 className={styles.root__title}>{tb('title')}</h2>
          <p
            className={styles.root__desc}
            dangerouslySetInnerHTML={{
              __html: tb('desc'),
            }}
          ></p>
          <AppMarket className={styles.root__app} />
        </div>

        <QrCode
          value={UNIFIED_APP_LINK}
          size={180}
          className={styles.root__qrCode}
        />
      </div>
    </div>
  )
}
